export const CometChat = () => {
	const regID = 12345
	const userName = "Joe Blogs"
	const picture = "https://media-exp1.licdn.com/dms/image/C4D0BAQE2u4Sjv5Klcw/company-logo_200_200/0/1576175308932?e=2159024400&v=beta&t=jrKRCqN78jt4947HCyNtw41wXEfRyRxN8-byEqkgJ1g"
	const regUid = regID.toString()

	const loadStage4 = () => {
		window.CometChatWidget.launch({
			alignment: "right",
			docked: "true",
			height: "550px",
			// left or right
			roundedCorners: "true",

			widgetID: "25e546fa-ff96-4639-898a-36705dbe7c82",
			width: "400px",
		})
	}

	const loadStage3 = () => {
		// You can now call login function.
		window.CometChatWidget.login({
			uid: regUid,
		}).then(loadStage4)
	}

	const loadStage2 = () => {
		window.CometChatWidget.createOrUpdateUser({
			avatar: picture,
			name: userName,
			uid: regUid,
		}).then(loadStage3)
	}

	const loadStage1 = () => {
		window.CometChatWidget.init({
			appID: "295327b7440d16a",
			appRegion: "us",
			authKey: "cbb5a796fc55414ec2dcdc598b3993c3cf435411",
		}).then(loadStage2)
	}

	const bootChatIfReady = () => {
		if (window.CometChatWidget === undefined) {
			setTimeout(bootChatIfReady, 250)
		} else { loadStage1() }
	}

	bootChatIfReady()

	return <script defer src="https://widget-js.cometchat.io/v2/cometchatwidget.js" />
}
